module.exports = __webpack_public_path__ + "02_very_short_brown.a004fd66.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer5/02_very_short_brown.png
// module id = lUrn
// module chunks = 0